module.exports = __webpack_public_path__ + "media/img/refresh-823333addd3518cd1950899c2080ee9b.svg";